module.exports = __webpack_public_path__ + "img/edit.c671247e.svg";